
/**
 * Format a number as currency
 * @param value Number to format as currency
 * @returns Formatted currency string
 */
export const formatCurrency = (value?: number): string => {
  if (value === undefined) return 'N/A';
  
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD'
  }).format(value);
};
